// [Hotfix 2026-08-01] 見 docs/audits/2026-07-27-frontend-limit-truncation-audit.md
//
// 背景：專案裡多處清單頁靠「猜一個夠大的 limit」（20/50/100/200/500/1000 全都有人
// 猜過）撐著，但正式資料量會隨時間成長，猜的 limit 遲早會被超過、資料就這樣默默
// 被截斷——而且後端多數查詢不是 order_by DESC（砍最舊，使用者較無感）就是根本沒有
// order_by（砍哪一筆不可預測）。2026-07-27 LeavesPage 月曆「月底請假消失」就是這個
// 模式第一次真的爆掉（單月 608 筆 > 原本猜的 500，見 9dd1260）。
//
// 為什麼不是把 limit 調更大：調大（例如 500 → 2000）治標不治本，只是把「爆炸」的
// 時間點往後推；且資料量更大之後，被砍掉的部分反而更沒人會逐筆核對發現。真正的
// 解法是「不用猜」：分頁抓到「這一批筆數 < pageSize」為止，代表這已經是最後一批，
// 保證資料抓完整，不需要事先知道總筆數會長到多大。

/**
 * 分頁抓完一份清單的完整資料，取代「猜一個夠大的 limit」。
 *
 * @param {(page: { skip: number, limit: number }) => Promise<{ data: any[] }>} fetchPage
 *   抓一頁資料的函式，接收 { skip, limit }，需回傳 axios response
 *  （本函式只讀取其中的 .data 陣列，其餘欄位如 headers 不處理）。
 * @param {{ pageSize?: number, maxPages?: number }} [options]
 *   - pageSize：每頁筆數，預設 500（專案目前已知最大單一清單為請假單月 608 筆，
 *     覆蓋現有頁面的既有用量、多數情況一次請求即可抓完，成長超過才會觸發第二頁）。
 *   - maxPages：安全閥，避免後端異常（例如某批一直剛好回滿 pageSize）時無限迴圈，
 *     預設 20（= 最多 10000 筆，遠超專案目前任何一份清單的實際量）。
 * @returns {Promise<any[]>} 彙總所有頁面後的完整陣列
 *
 * 注意：本函式刻意不吞例外——fetchPage 拋出的錯誤會直接往外拋出，交由呼叫端原本
 * 的 try/catch 處理，行為與各頁面原本單次 fetch 失敗時一致。
 */
export async function fetchAllPages(fetchPage, { pageSize = 500, maxPages = 20 } = {}) {
    let collected = [];
    for (let page = 0; page < maxPages; page += 1) {
        const res = await fetchPage({ skip: page * pageSize, limit: pageSize });
        const batch = res.data || [];
        collected = collected.concat(batch);
        if (batch.length < pageSize) break; // 這一批沒抓滿，代表已經是最後一批
    }
    return collected;
}
